export namespace OffboardComponentsActions{
    export class SetAllOffboardComponents {
        static readonly type = '[OffboardComponents] SetAllOffboardComponents';
        constructor() {}
    }
}